import axios from "axios";
import { log } from "@/plugins/consoleLogger";
import { commandsUrl } from "../moduleUrls";

const startSession = async (data) => {
  try {
    const res = await axios.post(
      `${commandsUrl}/START_SESSION`,
      {
        token: data.token,
        location_id: data.locationId,
        evse_uid: data.evseUid
      },
      {
        timeout: 30000
      }
    );

    log("log", res);

    if (res.status === 200) {
      return res;
    } else {
      throw new Error("Unable to acess Commands API");
    }
  } catch (err) {
    log("error", `Failed Backoffice call with: ${err.toString()}`);
    throw new Error("Unable to acess Commands API");
  }
};

const getCommand = async (uid) => {
  try {
    const res = await axios.post(
      `${commandsUrl}/result`,
      {
        uid
      },
      {
        timeout: 30000
      }
    );

    log("log", res);

    if (res.status === 200) {
      return res;
    } else {
      throw new Error("Unable to acess Commands API");
    }
  } catch (err) {
    log("error", `Failed Backoffice call with: ${err.toString()}`);
    throw new Error("Unable to acess Commands API");
  }
};

const stopSession = async (id) => {
  try {
    const res = await axios.post(
      `${commandsUrl}/STOP_SESSION`,
      {
        session_id: id
      },
      {
        timeout: 30000
      }
    );

    log("log", res);

    if (res.status === 200) {
      return res;
    } else {
      throw new Error("Unable to acess Commands API");
    }
  } catch (err) {
    log("error", `Failed Backoffice call with: ${err.toString()}`);
    throw new Error("Unable to acess Commands API");
  }
};

export { startSession, getCommand, stopSession };
